<section *ngIf="!popularCities || popularCities.length > 0" [ngClass]="{'texts': homeTexts}" class="container feature-categories popular-cities rec-pro">
  <div class="container-fluid">
    <div class="sec-title places-title">
      <h2><span>{{'t-first-home-mob' | translate}} </span>{{'t-second-home-mob' | translate}}</h2>
    </div>
    <div class="row">
      <ng-container *ngIf="placeholder">
        <div class="col-6 col-md py-2">
          <div class="popular-city placeholder-wave">
            <a>
              <div class="city-img">
                <svg class="bd-placeholder-img card-img-top radius-10" width="100%" height="115"
                  xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                  preserveAspectRatio="xMidYMid slice" focusable="false">
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
                <div class="city-name"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-6 col-md py-2">
          <div class="popular-city placeholder-wave">
            <a>
              <div class="city-img">
                <svg class="bd-placeholder-img card-img-top radius-10" width="100%" height="115"
                  xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                  preserveAspectRatio="xMidYMid slice" focusable="false">
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
                <div class="city-name"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-6 col-md py-2">
          <div class="popular-city placeholder-wave">
            <a>
              <div class="city-img">
                <svg class="bd-placeholder-img card-img-top radius-10" width="100%" height="115"
                  xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                  preserveAspectRatio="xMidYMid slice" focusable="false">
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
                <div class="city-name"></div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-6 col-md py-2">
          <div class="popular-city placeholder-wave">
            <a>
              <div class="city-img">
                <svg class="bd-placeholder-img card-img-top radius-10" width="100%" height="115"
                  xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                  preserveAspectRatio="xMidYMid slice" focusable="false">
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#868e96"></rect>
                </svg>
                <div class="city-name"></div>
              </div>
            </a>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="popularCities && popularCities.length > 0 && popularCities.length % 2 === 0">
        <div [ngClass]="{'d-none': placeholder}" *ngFor="let city of popularCities; let i = index"
          class="col-6 col-md py-2">
          <div class="popular-city"
            (click)="searchByLocation(city?.country, city?.region, city?.district, city?.county)">
            <div class="city-img">
              <img alt="{{city.name}}" (error)="imageError($event)"
                src="{{city.image ? city.image : 'assets/images/locations/'+city.countryName+'/'+i+'.jpg'}}">
              <div class="city-name">{{city.name}}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
